/**
 * Checks if input is a valid URL (with or without protocol)
 * Matches: https://example.com, http://example.com, www.example.com, example.com/path
 */
export function isUrlValid(input: string): boolean {
  return /^(https?:\/\/)?(www\.)?[a-z0-9-]+(\.[a-z0-9-]+)+(\/.*)?$/i.test(
    input.trim()
  );
}

/**
 * Ensures URL has https:// protocol
 * If input is a valid URL without protocol, adds https://
 * If input already has http:// or https://, returns as-is
 * If input is not a valid URL, returns as-is
 */
export function ensureHttpsProtocol(input: string): string {
  const trimmed = input.trim();

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  if (isUrlValid(trimmed)) {
    return `https://${trimmed}`;
  }

  return trimmed;
}
